module.exports = __webpack_public_path__ + "img/product-section-two-bg.53458a67.png";